import React from "react";
import "./index.css";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import {getSchoolYear} from "../../../../utils/authority";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import BusRouteController from "../../../../services/system/bus/bus-route-controller";
import Utils from "../../../../utils/utils";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import StudentController from "../../../../services/system/student/student-controller";
import {Month} from "../../student/attendance";
import ModalDetailPaymentEat from "./modalDetailPaymentEat";
registerLocale("vi", vi);


class EatPaymentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listReportPayment: [],
            "assistant1Name": "",
            "busRouteName": "",
            "driverName": "",
            "customerState": "ALL",
            "studentName": "",
            "sort": "created_at desc",
            assistant1Id: "",
            assistant1Username: "",
            driverId: "",
            driverUsername: "",

            listData: [],
            countStates: [],

            pageNumber: 0,
            pageSize: 10,
            totalItem: 0,

            listStyleStatus: [],
            listStudent: [],
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Tên học sinh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "title",
                    name: "Lớp",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "code",
                    name: "Mã thực đơn",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "total",
                    name: "Hình thức đóng tiền",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "paid",
                    name: "Đã đóng",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "pay",
                    name: "Tổng tiền",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "total",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.searchBusUserPayment()
        this.reportBusUserPayment()
        this.getListStudent()
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.searchBusUserPayment();
            }
        );
    };
    searchBusUserPayment() {
        let payload = {
            "assistant1Name": "",
            "busRouteName": this.state.busRouteName,
            "driverName": "",
            "state": this.state.customerState,
            "studentName": this.state.studentName,
            "pageNumber": this.state.pageNumber,
            "pageSize": this.state.pageSize,
            "sort": "created_at desc",
        };
        BusRouteController.searchBusUserPayment(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    reportBusUserPayment() {
        let payload = {
        };
        BusRouteController.reportBusUserPayment(payload, res => {
            this.setState({
                listStyleStatus: res.data,
            });
        })
    }
    onhandleSearch() {
        this.searchBusUserPayment()
    }
    onHandleRefresh() {
        this.setState({
            busRouteName: "",
            assistant1Id: "",
            assistant1Name: "",
            assistant1Username: "",

            driverId: "",
            driverName: "",
            driverUsername: "",

            state: "ACTIVE",
            listData: [],
            pageNumber: 0,
            totalItem: 0,
        }, ()=>{
            this.searchBusUserPayment()
        });
    }
    renderMonth() {
        return Month.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Đăng ký mới"
            },
            {
                "id": "Hủy dịch vụ",
                "name": "Đăng ký mới"
            },
            {
                "id": "Đã thanh toán",
                "name": "Đang khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getStatePayment(state){
        if (state == "NEW_REGISTER"){
            return "Đăng ký mới"
        }else if (state == "PAID"){
            return "Đã thanh toán"
        }else if (state == "CANCEL"){
            return "Đã hủy"
        }
        return ""
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: -1,
            code: "",
            ethnic: "",
            fullName: this.state.studentName,
            gender: "",
            grade: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    updateViewPayment () {
        this.searchBusUserPayment()
    }
    getNumberPaymentReport(state){
        for (let pos in this.state.listStyleStatus){
            if (this.state.listStyleStatus[pos]?.state == state)
                return this.state.listStyleStatus[pos].total
        }
        return 0
    }
    render() {
        let {listData, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="payment-eat" parentClass="menu-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                                <div className="content-loading col-12 ml-3 align-items-center"
                                     style={{display: 'block'}}>
                                    <div className="spinner-grow text-info"/>
                                </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý thanh toán ăn"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên lớp</label>
                                                <input
                                                    placeholder="Nhập tên lớp"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.busRouteName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({busRouteName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Mã lớp</label>
                                                <input
                                                    placeholder="Mã lớp"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.busRouteName}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({busRouteName: val.target.value.trim()})
                                                    }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        }, () =>{
                                                            this.searchBusUserPayment()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex mt-2">
                                                <label className="label-item col-md-4">Tháng</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        }, () =>{
                                                            this.searchBusUserPayment()
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderMonth()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>

                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm ml-3"
                                                    onClick={() => this.onHandleRefresh()}
                                                >
                                                    Refresh
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                                <div className="col-md-12 col-xs-12 col-sm-3 col-12 p-0 pr-md-3 d-flex row mb-2">
                                    <button
                                        type="button"
                                        className="btn bg-secondary text-white position-relative mr-2"
                                        title='Tất cả'
                                        style= {this.state.listStyleStatus["ALL"]}
                                        onClick={() => this.setState({customerState: "ALL"}, ()=>{
                                            this.onhandleSearch()
                                        })}
                                    >
                                        Tất cả
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                            {this.getNumberPaymentReport("ALL")}
                                            <span className="visually-hidden"></span>
                                                          </span>
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary text-white position-relative mr-2"
                                        title='Chưa thanh toán'
                                        style= {this.state.listStyleStatus["ALL"]}
                                        onClick={() => this.setState({customerState: "NEW_REGISTER"}, ()=>{
                                            this.onhandleSearch()
                                        })}
                                    >
                                        Chưa thanh toán
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                            {this.getNumberPaymentReport("NEW_REGISTER")}
                                            <span className="visually-hidden"></span>
                                                          </span>
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-success text-white position-relative mr-2"
                                        title='Đã thanh toán'
                                        style= {this.state.listStyleStatus["ALL"]}
                                        onClick={() => this.setState({customerState: "PAID"}, ()=>{
                                            this.onhandleSearch()
                                        })}
                                    >
                                        Đã thanh toán
                                        <span
                                            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                            {this.getNumberPaymentReport("PAID")}
                                            <span className="visually-hidden"></span>
                                                          </span>
                                    </button>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                    clickSort={data => {
                                                    }}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                        listData.length > 0 &&
                                                        listData?.map((row, index) => (
                                                            <tr style={{height: 50}}>
                                                                <td style={{textAlign: "center"}} scope="row">
                                                                    {" "}
                                                                    {this.state.pageNumber * this.state.pageSize +
                                                                        index +
                                                                        1}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.studentName}
                                                                </td>
                                                                <td style={{textAlign: "left"}} scope="row">
                                                                    {row.routeName}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {row.busTypeRes?.name}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {Utils.formatMoney(parseFloat(row.payment))}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {Utils.formatMoney(parseFloat(row.discount))}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {Utils.formatMoney(parseFloat(row.totalMoney))}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    {this.getStatePayment(row.state)}
                                                                </td>
                                                                <td style={{textAlign: "center"}}>
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row, showModalDetailPayment: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDetailPaymentEat
                    show={this.state.showModalDetailPayment}
                    onHide={() => this.setState({showModalDetailPayment: false})}
                    onRefresh={() => this.updateViewPayment()}
                    item={this.state.itemSelected}
                    routeBusName={this.state.routeBusName}
                />
            </div>
        );
    }
}

export default EatPaymentManagement;
